const section = {
    about: 'À propos de moi',
    projects: 'Projets',
    blogs: 'Blogs',
    skills: 'Compétences',
    contact: 'Contactez-moi 🤙',
    projectDetails: 'Détails',
    seeMoreGithub: 'Voir plus sur GitHub',
    moreArticle: 'Plus d\'articles',
    downloadResume: 'Télécharger le CV',
};

export default section;
